<template>
	<div class="footbar">
		<!--底部导航栏 -->
		<van-tabbar v-model="active" :route="route" replace inactive-color="#222222" active-color="#f24d38" :z-index="2000">
			<van-tabbar-item icon="home-o" to="/home">首页</van-tabbar-item>
			<van-tabbar-item icon="search" to="/Brand">找厂家</van-tabbar-item>
			<van-tabbar-item icon="apps-o" to="/Class">分类</van-tabbar-item>
			<van-tabbar-item icon="shopping-cart-o" @click="toPath('/Carts')">购物车</van-tabbar-item>
			<van-tabbar-item icon="contact" @click="toPath('/Min')">我的</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
	export default {
		name: 'Footbar',
		data() {
			return {
				active: 0,
				route: true,
				url: ''
			}
		},
		methods: {
			toPath(path) {
				this.whatLogin((bool) => {
					if (bool) {
						this.$router.push({
							path: path
						});
					} else {
						this.$router.push({
							path: 'login'
						});
					}
				})
			},
		},
		components: {

		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/footbar.vue